import { IScreen } from './iScreen';
import InteractionState from './game/interactionState';

// Read-only view of the persistent interaction cache: how many entities of
// each kind the player has killed/collected/opened across all sessions.
class StatsScreen implements IScreen{

    constructor(){

    }

    setup(){

    }

    windowResized(): void {

    }

    // Friendly label per entity kind; falls back to the raw kind.
    label(kind: string): string {
        let labels: {[k: string]: string} = {
            chicken: "Chickens killed",
            spider: "Spiders killed",
            chest: "Chests opened",
            item: "Items collected",
            coin: "Coins collected",
            heart: "Hearts collected",
            egg: "Eggs collected"
        };
        return labels[kind] || kind;
    }

    draw(){
        buffer.background(0);

        buffer.textAlign(buffer.CENTER, buffer.CENTER);
        buffer.fill(255);
        buffer.textSize(35);
        buffer.noStroke();
        buffer.text("Interaction Stats", 0, -buffer.height/2 + 60);

        let stats = InteractionState.getStats();

        if(stats.length === 0){
            buffer.textSize(16);
            buffer.fill(180);
            buffer.text("No interactions recorded yet.", 0, 0);
        }else{
            buffer.textSize(16);
            buffer.fill(200);
            buffer.text(`Total: ${InteractionState.total()}`, 0, -buffer.height/2 + 110);

            let lineHeight = 26;
            let startY = -((stats.length - 1) * lineHeight) / 2;
            for(let i = 0; i < stats.length; i++){
                let y = startY + i * lineHeight;
                buffer.fill(255);
                buffer.textAlign(buffer.RIGHT, buffer.CENTER);
                buffer.text(this.label(stats[i].kind), -10, y);
                buffer.textAlign(buffer.LEFT, buffer.CENTER);
                buffer.fill(205 + (p5js.sin(p5js.frameCount / 5.0) * 25), 0, 0);
                buffer.text(`${stats[i].count}`, 10, y);
            }
        }

        buffer.textAlign(buffer.CENTER, buffer.CENTER);
        buffer.textSize(24);
        buffer.fill(205 + (p5js.sin(p5js.frameCount / 5.0) * 25), 0, 0);
        buffer.text("> Return <", 0, buffer.height/2 - 60);
    }

    keyPressed(){
        if(p5js.keyCode === p5js.ESCAPE || p5js.keyCode == p5js.ENTER || p5js.key == ' '){
            currentScreen = "mainMenu";
            iScreen = screens[currentScreen];
            return;
        }
    }

    keyReleased(){

    }

    returnToMenu(){
        currentScreen = "mainMenu";
        iScreen = screens[currentScreen];
    }

    mousePressed(){
        this.returnToMenu();
    }

    mouseReleased(){

    }

    touchStarted(){
        this.returnToMenu();
    }

    touchEnded(){

    }

    touchMoved(): void {

    }

    mouseWheel(event: any): void {

    }

}

export default StatsScreen;
